import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 登录
 */
export const login = (params = {}) => {
    return postWithJson('/roc/login.np', params)
}
